export default __webpack_public_path__ + "static/media/GuyAnimation7.8474fd64.svg";